// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3b3ceefe","239":"ef3fadeb","455":"0e4e10de"}[chunkId] + ".chunk.js";
};